import React from 'react';
import { ArcGrid, ArcSkeleton, ArcStack, ArcText } from '@src/core/ui';
import { ArcDroneIcon } from '@src/core/widgets';
import { colors } from './constant';
import { DroneStatusType, useDroneProvider } from '@src/core/features';

const PreFlightCheckListPage: React.FC = () => {
  const { drones, isLoading } = useDroneProvider();

  const sortedDrones = React.useMemo(() => {
    return [...drones].sort((a, b) => {
      if (a.status === DroneStatusType.MISSION && b.status !== DroneStatusType.MISSION) return -1;
      if (a.status !== DroneStatusType.MISSION && b.status === DroneStatusType.MISSION) return 1;

      if (a.status === DroneStatusType.IDLE && b.status !== DroneStatusType.IDLE) return -1;
      if (a.status !== DroneStatusType.IDLE && b.status === DroneStatusType.IDLE) return 1;

      return 0;
    });
  }, [drones]);



  return (
    <ArcStack p={5}>
      <ArcStack width='100%' spacing={6}>
        <ArcStack spacing={1}>
          <ArcText.h2 fontWeight={500}>Fleet Status </ArcText.h2>
          <ArcText.h5 color='text.secondary'> Check operational status of all drones in real-time  </ArcText.h5>
        </ArcStack>

        {isLoading 
          ? <Loading /> 
          : <ArcGrid container spacing={4}>
            {sortedDrones.map((drone) => (
              <ArcGrid key={drone.id} size={1.5}>
                <ArcStack alignItems='center'>
                  <ArcDroneIcon 
                    width={42} 
                    height={42} 
                    iconColor={colors[drone.status] || '#666666'} />
                  <ArcText.caption
                    mt={1}
                    fontSize={12} 
                    textAlign='center'
                    color={colors[drone.status] || 'text.secondary'}> 
                    {drone.name} ({drone.serialNumber})  
                  </ArcText.caption>
                  <ArcText.caption 
                    fontSize={12}
                    textAlign='center'
                    color={colors[drone.status] || 'text.secondary'}> 
                    {drone.status}  
                  </ArcText.caption>
                </ArcStack>
              </ArcGrid>
            ))}
          </ArcGrid>}
      </ArcStack>
    </ArcStack>
  );
};

const Loading: React.FC = () => (
  <ArcGrid container spacing={4}>
    <ArcGrid size={1.5}> <ArcSkeleton height={100} /> </ArcGrid>
    <ArcGrid size={1.5}> <ArcSkeleton height={100} /> </ArcGrid>
    <ArcGrid size={1.5}> <ArcSkeleton height={100} /> </ArcGrid>
    <ArcGrid size={1.5}> <ArcSkeleton height={100} /> </ArcGrid>
    <ArcGrid size={1.5}> <ArcSkeleton height={100} /> </ArcGrid>
    <ArcGrid size={1.5}> <ArcSkeleton height={100} /> </ArcGrid>
    <ArcGrid size={1.5}> <ArcSkeleton height={100} /> </ArcGrid>
    <ArcGrid size={1.5}> <ArcSkeleton height={100} /> </ArcGrid>
  </ArcGrid>
);

export default PreFlightCheckListPage;